<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<template>
  <bread-crumbs :labels="[module_name, harvest_process.name]"></bread-crumbs>

  <div class="mt-8 flex flex-col">
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.week") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.registered_at") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.producer") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.batch_code") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.harvested_packages") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.total_weight") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.discarded_weight") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.ok_weight") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.crop_type") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.crop_variety") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.buyer") }}
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                class="table-row"
                v-for="harvested_batch in harvested_batches"
                :key="harvested_batch.id"
              >
                <td class="table-cell">
                  {{ harvested_batch.week }}
                </td>
                <td class="table-cell">
                  {{ dateFormatter(harvested_batch.registered_at) }}
                </td>
                <td class="table-cell">
                  {{
                    harvested_batch.producer?.name ||
                    harvested_batch.organization.name
                  }}
                </td>
                <td class="table-cell-main">
                  {{ harvested_batch.batch_code }}
                </td>
                <td class="table-cell">
                  <h3
                    v-for="harvested_package in harvested_batch.harvested_packages"
                    :key="harvested_package.id"
                  >
                    {{ numberWithPrecision(harvested_package.number) }}
                    {{ harvested_package.crop_har_package.name }}
                  </h3>
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(harvested_batch.total_weight) }}
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(harvested_batch.discarded_weight) }}
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(harvested_batch.ok_weight) }}
                </td>
                <td class="table-cell">
                  {{ harvested_batch.crop_type.name }}
                </td>
                <td class="table-cell">
                  {{ harvested_batch.crop_variety.name }}
                </td>
                <td class="table-cell">
                  {{ harvested_batch.buyer_name }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div />
</template>

<script>
import Requester from "@/views/open_queries/requesters/organization/basic_production/process/show_production.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  name: "OQOrgBasicProductionProcessShowProduction",
  components: { BreadCrumbs },
  props: {
    harvest_process_id: { required: true },
    organization_id: { required: true }
  },
  data() {
    return {
      harvest_process: {},
      harvested_batches: []
    };
  },
  methods: {
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process = response.data;
    },
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvested_batches = response.data;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => {
        this.fetchHarvestProcess();
        this.fetchHarvestedBatches();
      })
    );
  }
};
</script>
